export const PEOPLE_DATA_RECEIVED = 'PEOPLE_DATA_RECEIVED'
export const PEOPLE_DATA_UNLOADED = 'PEOPLE_DATA_UNLOADED'
